// Guards the maintenance panel. The code is held by the WeAreDevelopers team
export const MAINTENANCE_CODE_MAX_LENGTH = 10

// Guessing is impractical already. The pause removes the possibility of someone
// patiently working through attempts on an idle phone.
const MAX_ATTEMPTS = 3
const LOCKOUT_SECONDS = 30

export const useMaintenanceAccess = () => {
  const config = useRuntimeConfig()
  const attempts = useState('maintenance-attempts', () => 0)
  const lockedUntil = useState<number | null>('maintenance-locked-until', () => null)

  const expectedCode = String(config.public.maintenanceCode || '')

  const lockedFor = computed(() => {
    if (!lockedUntil.value) {
      return 0
    }

    return Math.max(0, Math.ceil((lockedUntil.value - Date.now()) / 1000))
  })

  const unlock = (code: string): boolean => {
    if (lockedFor.value > 0) {
      return false
    }

    // Compared exactly, including case. A code is copied from a sheet rather than
    // remembered, so being forgiving buys nothing and weakens it.
    if (code !== '' && code === expectedCode) {
      attempts.value = 0
      lockedUntil.value = null

      return true
    }

    attempts.value += 1

    if (attempts.value >= MAX_ATTEMPTS) {
      attempts.value = 0
      lockedUntil.value = Date.now() + LOCKOUT_SECONDS * 1000
    }

    return false
  }

  return { unlock, lockedFor }
}
